import "../../styles/notification/notification.css";
import { BsBellFill } from "react-icons/bs";

const BlockNotification = ({ currency, closeModal, data }) => {
  return (
    <>
      <div className='blockNotification'>
        <div className='reminderNot'>
          <div></div>
          <div className='reminderClockdiv'>
            <BsBellFill color='#B52E76' size={30} />
          </div>
          <div className='inforem87746'>
            <h3>Recover your goods on loan</h3>
            <p className='reminderInfoPa222'>
              This is a gentle reminder that the goods you loan to {data.customerName} is due for collection. The customer has to pay a total of
            </p>
            <p>
              {currency} {data.balance}{" "}
            </p>
          </div>
        </div>
        <button onClick={() => closeModal(false)}>I acknowledge</button>
      </div>
    </>
  );
};

export default BlockNotification;
